import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

import api from './../../service/api';
import { formatDate } from '../../service/format';
import { calculateDateInterval, downloadCsv } from '../../service/handle';

const PartControl = () => {
    let emptyPartControl = {
        truck: '',
        description: '',
        axle: null,
        side: '',
        kilometer_initial: null,
        kilometer_final: null,
        datecontrol_initial: null,
        datecontrol_final: null
    };

    const sides = [
        { label: 'Direito', value: 'left'},
        { label: 'Esquerdo', value: 'right'},
        { label: 'Ambos', value: 'both'},
    ];

    const [partControls, setPartControls] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [truck, setTruck] = useState('all');
    const [filterTruck, setFilterTruck] = useState([{ label: 'Todos', value: 'all' }]);
    const [partControlDialog, setPartControlDialog] = useState(false);
    const [partControl, setPartControl] = useState({...emptyPartControl});
    const [submitted, setSubmitted] = useState(false);
    const [deletePartControlDialog, setDeletePartControlDialog] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _partControl = { ...partControl };
        _partControl[`${name}`] = val;
        console.log(_partControl);
        
        setPartControl(_partControl);
    }

    const openNew = () => {
        
        setPartControl({...emptyPartControl});
        setSubmitted(false);
        setDisabled(false);
        setPartControlDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setPartControlDialog(false);
        setDisabled(false);
    }

    const handlePartControl = () => {
        if(!partControl.truck || !partControl.kilometer_initial || !partControl.description
            || !partControl.datecontrol_initial
                || partControl.axle > 99 )
                return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _partControl = {...partControl};

        if((partControl.datecontrol_initial && typeof partControl.datecontrol_initial === 'object') || false)
            _partControl.datecontrol_initial = partControl.datecontrol_initial.getTime();

        if((partControl.datecontrol_final && typeof partControl.datecontrol_final === 'object') || false)
            _partControl.datecontrol_final = partControl.datecontrol_final.getTime();
        
        api().post(!partControl.code ? '/partControl/create' : '/partControl/update', {..._partControl}).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listPartControls();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        }).catch(error => {
            console.log(error);
            
            hideDialog();
            toast.current.show({severity: 'warn', summary: 'Atenção', detail: 'Não foi possível realizar a operação, entre em contato com o suporte!'});
        });
    }

    const __enricherPartControl = (partControl) => {
        partControl.axleEnrichered = partControl.axle || '-';
        partControl.sideEnrichered = partControl.side === 'left' ? 'Esquerdo' : (partControl.side === 'right' ? 'Direito' : (partControl.side === 'Ambos' ? 'Ambos' : '-'));
        partControl.kilometer_total = 
            partControl.kilometer_final && 
            partControl.kilometer_initial ? 
                (Math.abs( partControl.kilometer_final - partControl.kilometer_initial)) : '-';
        partControl.date_interval = calculateDateInterval(partControl.datecontrol_initial, partControl.datecontrol_final);
        return partControl;
    }

    const listPartControls = (truckSelected = 'all') => {
        setLoading(true);
        var url = truckSelected !== 'all' ? '/partControl/truck/' + truckSelected : '/partControl/list';
        api().get(url).then(response => {
            if(response.status === 200 && response.data.result){
                setPartControls(response.data.data.map(__enricherPartControl));
            }
            setLoading(false);
        });
    }

    const editPartControl = (rowData) => {
        setPartControl(rowData);
        setSubmitted(false);
        setPartControlDialog(true);
        setDisabled(false);
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                var filter = [{ label: 'Todos', value: 'all' }];
                response.data.data.forEach(truck => {
                    filter.push({ label: truck.plate, value: truck.code });
                });
                setFilterTruck(filter);
                setTrucks(response.data.data);
            }
        });
    }

    const handleDeletePartControl = () => {
        setLoading(true);
        api().delete('/partcontrol/' + partControl.code).then(response => {
            setDeletePartControlDialog(false);
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listPartControls();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Controle de Peças</h5>
            <div className="field m-0">
                <Dropdown value={truck} id="truckFilter" options={filterTruck} onChange={(e) => {
                    setTruck(e.value);
                    listPartControls(e.value);
                }} optionLabel="label" optionValue='value' placeholder="Selecione um caminhão" />
            </div>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handlePartControl} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions" style={{ whiteSpace: 'nowrap' }}>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info mr-2" onClick={() => editPartControl(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => {
                    setDeletePartControlDialog(true);
                    setPartControl({...rowData});
                }} />
            </div>
        );
    }

    const hideDeletePartControlDialog = () => {
        setPartControl({...emptyPartControl});
        setDeletePartControlDialog(false);
    }

    const deletePartControlDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeletePartControlDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeletePartControl} />
        </>
    );

    const [loadingExport, setLoadingExport] = useState(false);
    const rightButton = () => (
        <>
            <Button label="Exportar" icon="pi pi-download" loading={loadingExport} className="p-button-text" onClick={() => {
                setLoadingExport(true);
                downloadCsv(['Descrição', 'Caminhão', 'Eixo', 'Lado', 'Km (Inicial)', 'Km (Final)',
            'Data (Inicial)', 'Data (Final)', 'Km (Total)', 'Intervalo'], partControls.map(data => {
                    var dateOptions = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                    }
                    return [
                        data.description,
                        (data.plate || '-').toUpperCase(),
                        data.axle,
                        (data.side === 'left' ? 'Esquerdo' : (data.side === 'right' ? 'Direito' : (data.side === 'Ambos' ? 'Ambos' : '-'))),
                        data.kilometer_initial,
                        data.kilometer_final,
                        data.datecontrol_initial ? new Date(data.datecontrol_initial).toLocaleDateString('pt-br', dateOptions) : '-',
                        data.datecontrol_final ? new Date(data.datecontrol_final).toLocaleDateString('pt-br', dateOptions) : '-',
                        data.kilometer_total,
                        data.date_interval
                    ];
                }), 'Controle_de_pecas_' + Date.now());
                setTimeout(() => {
                    setLoadingExport(false)
                }, 3000);
            }} />
        </>
    );
   
    useEffect(() => {
        console.log(partControl);

        listPartControls();
        listTrucks();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightButton}></Toolbar>

                    <DataTable ref={dt} value={partControls} loading={loading}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="description" header="Descrição"></Column>
                        <Column field="plate"  header="Caminhão" sortable></Column>
                        <Column field="axleEnrichered" header="Eixo"></Column>
                        <Column field="sideEnrichered" header="Lado"></Column>
                        <Column field="kilometer_initial"  header="Km (Inicial)"></Column>
                        <Column field="kilometer_final"  header="Km (Final)"></Column>
                        <Column field="datecontrol_initial" body={rowData => formatDate(rowData.datecontrol_initial, false)} header="DT (Inicial)"></Column>
                        <Column field="datecontrol_final" body={rowData => rowData.datecontrol_final ? formatDate(rowData.datecontrol_final, false) : '-'} header="DT (Final)"></Column>
                        <Column field="kilometer_total"  header="Km (Total)"></Column>
                        <Column field="date_interval"  header="Intervalo"></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={partControlDialog} style={{ width: '450px' }} header="Controle de Peças" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="descriptionPart">Descrição</label>
                                <InputText disabled={disabled} id="descriptionPart" required autoFocus value={partControl.description}  onChange={(e) => onInputChange(e, 'description')} />
                                {submitted && !partControl.description && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>
                        
                        
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='side'>Lado (Opcional)</label>
                                <Dropdown value={partControl.side} id="side" options={sides} onChange={(e) => onInputChange(e, 'side')} optionLabel="label" optionValue='value' placeholder="Selecione um lado" />

                            </div>
                            
                            <div className="field col">
                                <label htmlFor="axle">Eixo (Opcional)</label>
                                <InputNumber disabled={disabled} id="axle" value={partControl.axle} mode='decimal' onChange={(e) => onInputChange(e, 'axle')} />
                            </div>
                        </div>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='truck'>Caminhão</label>
                                <Dropdown value={partControl.truck} id="truck" options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                                {submitted && !partControl.truck && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>
                        </div>
                        <div className="field">
                            <label htmlFor="datecontrol_initial">Data da Troca (Inicial)</label>
                            <Calendar id="datecontrol_initial" disabled={disabled} dateFormat="dd/mm/yy" locale='pt-br' value={partControl.datecontrol_initial ? new Date(partControl.datecontrol_initial) : null} onChange={(e) => onInputChange(e, 'datecontrol_initial')} showIcon />
                            {submitted && !partControl.datecontrol_initial && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="kilometer_initial">Quilometragem (Inicial)</label>
                                <InputNumber disabled={disabled} id="kilometer_initial" currency='BRL' minFractionDigits={0} mode='decimal' value={partControl.kilometer_initial} onValueChange={(e) => onInputChange(e, 'kilometer_initial')}  />
                                {submitted && !partControl.kilometer_initial && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                            </div>
                        </div>

                        {partControl.code ? (
                            <>
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label htmlFor="kilometer_final">Quilometragem (Final)</label>
                                        <InputNumber id="kilometer_final" currency='BRL' minFractionDigits={0} mode='decimal' value={partControl.kilometer_final} onValueChange={(e) => onInputChange(e, 'kilometer_final')}  />
                                        {submitted && !partControl.kilometer_final && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                                    </div>
                                </div>
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label htmlFor="datecontrol_final">Data da Troca (Final) </label>
                                        <Calendar id="datecontrol_final" dateFormat="dd/mm/yy" locale='pt-br' value={partControl.datecontrol_final ? new Date(partControl.datecontrol_final) : null} onChange={(e) => onInputChange(e, 'datecontrol_final')} showIcon />
                                        {submitted && !partControl.datecontrol_final && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                                    </div>
                                </div>
                            </>
                        ) : ''}
                    </Dialog>

                    <Dialog visible={deletePartControlDialog} style={{ width: '450px' }} header="Atenção" modal footer={deletePartControlDialogFooter} onHide={hideDeletePartControlDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {partControl && <span>Você tem certeza que deseja remover este registro?</span>}
                        </div>
                    </Dialog>
                    
                </div>
            </div>
        </div>
    );
}

export default PartControl;